import React from 'react';
import './BackgroundWaterEffects.css';

export const BackgroundWaterEffects: React.FC = () => {
  return (
    <div className="background-water-effects">
      {/* Animated water waves */}
      <div className="water-wave wave-1"></div>
      <div className="water-wave wave-2"></div>
      <div className="water-wave wave-3"></div>
      
      {/* Floating particles */}
      <div className="water-particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
        <div className="particle particle-6"></div>
      </div>
      
      {/* Gentle ripple overlay */}
      <div className="gentle-ripples">
        <div className="ripple-overlay overlay-1"></div>
        <div className="ripple-overlay overlay-2"></div>
        <div className="ripple-overlay overlay-3"></div>
      </div>
    </div>
  );
};